import React from 'react';
import { Box, Flex } from 'rebass';
import colors from '../../theme/colors';

interface ProgressBarProps {
  complete: number;
  total: number;
  label?: string;
  color?: string; // Optional bar color
}

const ProgressBar: React.FC<ProgressBarProps> = ({
  complete,
  total,
  label,
  color = colors.primary,
}) => {
  const safeTotal = total > 0 ? total : 1;
  const safeComplete = Math.max(0, Math.min(complete, safeTotal));
  const percent = Math.round((safeComplete / safeTotal) * 100);

  return (
    <Box sx={{ width: '100%' }}>
      {label && (
        <Box sx={{ marginBottom: 4, fontSize: 14, color: '#333' }}>{label}</Box>
      )}
      <Box
        sx={{
          background: '#e0e0e0',
          borderRadius: 8,
          height: 16,
          width: '100%',
          overflow: 'hidden',
        }}
        aria-label={label || 'progress bar'}
        role="progressbar"
        aria-valuenow={percent}
        aria-valuemin={0}
        aria-valuemax={100}
      >
        <Box
          sx={{
            width: `${percent}%`,
            background: color,
            height: '100%',
            borderRadius: 8,
            transition: 'width 0.3s cubic-bezier(.4,0,.2,1)',
          }}
        />
      </Box>
      <Flex alignItems="center" justifyContent="space-between" mt={1}>
        <Box
          sx={{ fontSize: 12, color: '#555' }}
        >{`${safeComplete} / ${safeTotal}`}</Box>
        <Box sx={{ fontSize: 12, color: '#555' }}>{percent}%</Box>
      </Flex>
    </Box>
  );
};

export default ProgressBar;
